import ZaiaCounter from "./ZaiaCounter";

export default ZaiaCounter;